import Image from 'app/Components/Shared/Image/image';
import React from 'react';
const FileInput = (props) => {
  return (
    <div className={`fileInput-wrapper ${props.isDraggingOver ? 'dragging' : ''}`}>
      <input type='file' name='fileInput' {...props} hidden />
      <div className='file-content'>
        <label> {props.label || ' ניתן להעלות או לגרור קובץ לכאן'}</label>
        <label className={`upload-file `} htmlFor='fileInput'>
          העלאת מסמך <Image src={require('./icons/upload.svg')} />
        </label>
      </div>
      {props.filename &&
        <div className='file-details'>
          <div className='single-file-upload' >
            {props.filename} <Image src={require('./icons/close.svg')} onClick={props.removeFile} />
          </div>
          {props.error &&
            <div className='error'>{props.error}</div>}

        </div>
      }

    </div>
  );
};

export default FileInput;
